import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import { SOUSCRIPTION } from '../../Utils/constant';
import { store } from '../../services/service';
import { useStoreForfait } from '../../store/Paramettre/forfaitStore';
import { SubmitButton } from '../Widget/SubmitButton';

export const Souscription = () => {
    const [paiementChoix, setPaiementChoix] = useState("MOMO");
    const forfait = useStoreForfait()
    const [isSubmit, setIsSubmit] = useState(false)

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();
    useEffect(() => {
        forfait.forfait({ page: 0, param: "", size: 1000 })
    }, [])

    const { id } = useParams()

    const submit = (data) => {
        setIsSubmit(true)
        const requestData = { ...data, raccordementId: Number(id) }
        store(SOUSCRIPTION, 'application/json', requestData).then((res) => {
            if (res.status === 200) {
                toast.success('Souscription éffectuée')
            }
        }).catch((err) => {
            setIsSubmit(false)
            toast.error(err?.response?.data?.donnee)
        })
    }
    return (
        <form onSubmit={handleSubmit(submit)} className="w-full flex flex-col  items-start  mt-6">
            <div className="flex flex-col items-center justify-center w-full gap-x-3">
                <label className="form-control   w-full">
                    <div className="label -mb-1">
                        <span className="label-text font-medium text-gray-400">
                            Canal de souscription
                        </span>
                    </div>
                    <select
                        {...register("canal", { required: true })}
                        value={paiementChoix}
                        onChange={(e) => setPaiementChoix(e.target.value)}
                        className="select select-bordered w-full h-10 lg:max-w-xs "
                    >
                        <option disabled selected>
                            choisissez un moyen ?
                        </option>
                        <option value="PORTAIL">Portail</option>
                        <option value="USSD">USSD</option>
                        <option value="MY_MTN">MyMtn</option>

                    </select>
                </label>
                <label className="form-control w-full">
                    <div className="label -mb-1">
                        <span className="label-text font-medium text-gray-400">
                            Moyen de paiements
                        </span>
                    </div>
                    <select
                        {...register("modePaiement", { required: true })}
                        value={paiementChoix}
                        onChange={(e) => setPaiementChoix(e.target.value)}
                        className="select select-bordered w-full h-10 lg:max-w-xs "
                    >
                        <option disabled selected>
                            choisissez un moyen ?
                        </option>
                        <option value="MOMO">MoMo</option>
                        <option value="AIRTIME">AirTime</option>
                    </select>

                </label>

                <label className="form-control w-full">
                    <div className="label -mb-1">
                        <span className="label-text font-medium text-gray-400">
                            Commentaire
                        </span>
                    </div>
                    <textarea
                        {...register("commentaire")}
                        placeholder="Votre commentaire" className="textarea textarea-bordered textarea-sm w-full lg:max-w-xs" ></textarea>
                </label>

                <label className="form-control w-full">
                    <div className="label -mb-1">
                        <span className="label-text font-medium text-gray-400">
                            Forfait souscrit
                        </span>
                    </div>
                    <select
                        {...register("forfaitId", { required: true })}
                        className="select select-bordered w-full h-10 lg:max-w-xs "
                    >
                        <option disabled selected>
                            choisissez un forfait ?
                        </option>
                        {
                            forfait?.data?.data?.map((item) => (
                                <option value={item.id}>{item.designation}</option>
                            ))
                        }
                    </select>
                </label>
            </div>
            <SubmitButton isSubmit={isSubmit} label={"Enregistrer"} />
        </form>
    )
}
